import useMode from '../stores/mode';
import useMarker from '../stores/marker';

import Delay from './Delay';

import ARFinder from './AR/Finder';
import ARScene from './AR/Scene';
import ARPreview from './AR/Preview';
import ARBackground from './AR/Background';
import AROverlay from './AR/Overlay';
import ARIndex from './AR/Index';

function AR() {
    const marker = useMarker();
    const mode = useMode();

    return (
        <section className="AR">
            {!marker.visible && <ARFinder></ARFinder>}

            <Delay delay="500">
                <ARScene></ARScene>
            </Delay>

            <ARPreview></ARPreview>

            <ARBackground></ARBackground>
            <AROverlay></AROverlay>

            <ARIndex></ARIndex>
        </section>
    );
}

export default AR;
